import { IFieldElem } from '@models/IFormData';
import { containsValue, getValueString } from '@utils/documentUtils';
import StatusBadge from '@atoms/Widgets/StatusBadge';
import { FC, useMemo } from 'react';
import './DocumentModalTitle.scss';
import clsx from 'clsx';

export interface IDocumentModalTitleProps {
    titleText: string | undefined;
    fieldsData: Record<string, IFieldElem>;
}

const DocumentModalTitle: FC<IDocumentModalTitleProps> = ({ titleText, fieldsData }: IDocumentModalTitleProps) => {
    const statusText = useMemo(() => {
        return getValueString('|Document|Статус', fieldsData);
    }, [fieldsData]);

    return (
        <div className="doc-modal-header">
            <div className={clsx('doc-modal-header-el', 'doc-modal-header-txt')}>{titleText}</div>
            {containsValue('|Document|Статус', fieldsData) && statusText && (
                <StatusBadge status={statusText} className="doc-modal-header-el doc-modal-header-status" />
            )}
        </div>
    );
};

export default DocumentModalTitle;
